// extracted by mini-css-extract-plugin
export default {"root":"UdEw0CwiQt3bzQs0bOa9","hiddenItems":"dxvta4X5Shg_2C8FOZ_B","hiddenItem":"PbdAQWyKTCGKw6eQ_GSP"};